// index.tsx
import React from "react";
import { StyledSkeleton } from "./styles";
import { SkeletonProps } from "./types";

/**
 * Componente Skeleton
 *
 * Um esqueleto para indicar carregamento de conteúdo.
 *
 * @param {number} width - Largura do esqueleto em porcentagem.
 * @param {number} height - Altura do esqueleto.
 * @param {number} [marginLeft=0] - Margem à esquerda.
 * @param {number} [marginRight=0] - Margem à direita.
 * @param {number} [marginTop=0] - Margem superior.
 * @param {number} [marginBottom=0] - Margem inferior.
 * @param {number} [borderRadius=0] - Raio da borda.
 */
export const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  marginBottom = 0,
  borderRadius = 0,
}) => {
  return (
    <StyledSkeleton
      width={width}
      height={height}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
      marginBottom={marginBottom}
      borderRadius={borderRadius}
    />
  );
};

export default Skeleton;
